(function () {
  'use strict';

  var APP_PROXY_BASE = '/apps/theme-api';
  var CUSTOMER_BASE_URL = APP_PROXY_BASE + '/customer/base';
  var SESSION_KEY = 'customer.base';
  var TTL_MS = 5 * 60 * 1000;
  var TIMEOUT_MS = 5000;

  function readCache() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.fetchedAt) return null;
      if (Date.now() - parsed.fetchedAt > TTL_MS) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        data: data,
        fetchedAt: Date.now()
      }));
    } catch (e) {}
  }

  function clearCache() {
    try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
  }

  function fetchWithTimeout(url) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, TIMEOUT_MS);
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      signal: controller.signal
    }).finally(function () { clearTimeout(timer); });
  }

  function fetchCustomer() {
    return fetchWithTimeout(CUSTOMER_BASE_URL)
      .then(function (res) {
        if (res.status === 401 || res.status === 403) {
          clearCache();
          return null;
        }
        if (!res.ok) throw new Error('unexpected status: ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (!json || json.loggedIn === false) {
          clearCache();
          return null;
        }
        if (!json.customer) return null;
        writeCache(json.customer);
        return json.customer;
      })
      .catch(function (err) {
        console.warn('[customer-session] fetch failed:', err);
        return readCache();
      });
  }

  function getCustomer(options) {
    var opts = options || {};
    if (!opts.forceRefresh) {
      var cached = readCache();
      if (cached) return Promise.resolve(cached);
    }
    return fetchCustomer();
  }

  var forceRefresh = !!window.__forceCustomerRefresh;
  var ready = getCustomer({ forceRefresh: forceRefresh });

  var resolve = window.__resolveCustomerReady;
  if (resolve) {
    ready.then(resolve);
  } else {
    window.customerReady = ready;
  }

  window.customerSession = {
    ready: window.customerReady || ready,
    get: getCustomer,
    refresh: function () { return getCustomer({ forceRefresh: true }); },
    clear: clearCache
  };
})();
